import { FC, useState, useEffect } from 'react';
import { translate } from 'translations';
import { AdminSearch, Button } from 'learning-panel-components';
import Tag from './tag';
import styles from './moreTags.module.scss';

const MoreTags: FC<MoreTagsProps> = (props: MoreTagsProps) => {
    const { tags, onClose, onApply, selectedTags } = props;
    const [search, setSearch] = useState<string>('');
    const [filteredTags, setFilteredTags] = useState<Tags[]>(tags);
    const [selectedMoreTags, setSelectedMoreTags] = useState<string[]>([]);

    useEffect(() => {
        setFilteredTags(tags.filter(tag => tag.name.toLowerCase().includes(search.toLowerCase())));
    }, [search, tags]);

    useEffect(() => {
        setSelectedMoreTags(selectedTags);
    }, [selectedTags.length]);

    const setTags = (tag: string) => {
        if (selectedMoreTags.includes(tag)) {
            setSelectedMoreTags(selectedMoreTags.filter(t => t !== tag));
        } else {
            setSelectedMoreTags([...selectedMoreTags, tag]);
        }
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.top}>
                <AdminSearch
                    placeholder="Search"
                    onSearchChange={(search: string) => setSearch(search)}
                    width="100%"
                    backgroundColor="rgba(230, 222, 255, 0.25)"
                    inputColor="#FFFFFF80"
                />
                <div className={styles.tags}>
                    {filteredTags.map(tag => (
                        <Tag
                            key={tag.name}
                            {...tag}
                            name={tag.displayName}
                            onClick={() => setTags(tag.name)}
                            isSelected={selectedMoreTags.includes(tag.name)}
                        />
                    ))}
                </div>
            </div>
            <div className={styles.bottom}>
                <Button
                    text={translate('Cancel')}
                    onClick={onClose}
                    type="textFlat"
                    className={styles.button}
                    lowerCase
                />
                <Button
                    text={translate('Apply')}
                    onClick={() => onApply(selectedMoreTags)}
                    type="gradientNoBorder"
                    lowerCase
                />
            </div>
        </div>
    );
};

interface MoreTagsProps {
    tags: Tags[];
    onClose: Function;
    onApply: Function;
    selectedTags: string[];
}

interface Tags {
    name: string;
    displayName: string;
    count: number;
    isSelected?: boolean;
}

export default MoreTags;
